import styled from "styled-components";
import theme from "themes/simple-theme";

interface IProps {
  primary?: boolean;
  secondary?: boolean;
  tertiary?: boolean;
  cancel?: boolean;
  panel?: boolean;
  active?: boolean;
  edit?: boolean;
  editLight?: boolean;
  reset?: boolean;
  thin?: boolean;
  wide?: boolean;
  wider?: boolean;
  fullWidth?: boolean;
  disabled?: boolean;
}

const ButtonWrapper = styled.div`
  /* Base Styling */
  cursor: pointer;
  text-align: center;
  display:inline-block;
  padding: 25px 15px;
  border: none;
  border-radius: 2px;
  min-width: 120px;
  * {
    text-decoration: none;
  }

  font-size: ${theme.fontSize.m};

  // Primary
  ${({ primary }: IProps) =>
    primary
      ? `
    background-color: ${theme.color.primary};

    * {color: ${theme.color.white};}

    `
      : ""}

  // Secondary
  ${({ secondary }: IProps) =>
    secondary
      ? `
    background-color: ${theme.color.secondary};
    * {color: ${theme.color.white};}
    `
      : ""}


  // Cancel
  ${({ cancel }: IProps) =>
    cancel
      ? `
    background-color: ${theme.color.red};
    * {color: ${theme.color.white};}
    `
      : ""}

  // Panel
  ${({ panel }: IProps) =>
    panel
      ? `
    background-color: ${theme.color.primary};
    * {color:${theme.color.white};}
    border-radius: 3px;
    font-size: ${theme.fontSize.s};
    padding: 10px 15px;
    `
      : ""}

  // Active
  ${({ active }: IProps) =>
    active
      ? `
    background-color: ${theme.color.tertiary};
    color: ${theme.color.white};
    border-radius: 3px;
    font-size: ${theme.fontSize.s};
    padding: 10px 15px;
    `
      : ""}

  // Reset
  ${({ reset }: IProps) =>
    reset
      ? `
    font-family: ${theme.fontFamily.black};
    font-size: ${theme.fontSize.s};
    * {color: #0063A7;}
    background-color: transparent;
      `
      : ""}
  // Thin Height
  ${({ thin }: IProps) => (thin ? "padding: 15px;" : "")}

  // Wide Width
  ${({ wide }: IProps) => (wide ? "width: 180px;" : "")}

  // Wider Width
  ${({ wider }: IProps) => (wider ? "width: 220px;" : "")}

  // Full Width
  ${({ fullWidth }: IProps) => (fullWidth ? "width: 100%;" : "")}

  // Disabled
  ${({ disabled }: IProps) =>
    disabled
      ? `
      pointer-events: none;
      background-color: ${theme.color.gray.light};
      * {color: ${theme.color.gray.medium};}
      `
      : ""}
`;

export default ButtonWrapper;



// WEBPACK FOOTER //
// ./src/components/common/ButtonWrapper.tsx